import LegalPage from "../components/LegalPage";

const SECTIONS = [
  {
    title: "Acceptance of these terms",
    paragraphs: [
      "By accessing or using sefkam.com (the \"Website\"), operated by SefKam Digital Solutions (\"SefKam\", \"we\", \"us\"), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please do not use the Website.",
    ],
  },
  {
    title: "Use of the Website",
    paragraphs: ["You agree to use the Website only for lawful purposes. In particular, you agree not to:"],
    items: [
      "Attempt to gain unauthorised access to the Website, its servers or connected systems.",
      "Use the contact form to send unlawful, abusive or unsolicited commercial content.",
      "Interfere with the Website's operation, including through automated high-volume requests.",
      "Misrepresent your identity or affiliation when contacting us.",
    ],
  },
  {
    title: "Informational content",
    paragraphs: [
      "The content on this Website — including service descriptions, articles and insights — is provided for general information purposes only. It does not constitute professional, legal or financial advice, and it does not form a binding offer. Any engagement between you and SefKam is governed by a separate written agreement.",
    ],
  },
  {
    title: "SefKam Home and forthcoming products",
    paragraphs: [
      "References on this Website to SefKam Home describe a product vision under development. Features, availability, timelines and specifications described are indicative, may change without notice, and do not constitute a commitment to release any particular product or feature.",
    ],
  },
  {
    title: "Intellectual property",
    paragraphs: [
      "All content on this Website — including text, design, graphics, logos and the SefKam name and brand — is the property of SefKam Digital Solutions or its licensors and is protected by applicable intellectual property laws. You may not reproduce, distribute or create derivative works from this content without our prior written consent, except for brief quotations with attribution.",
    ],
  },
  {
    title: "Third-party links",
    paragraphs: [
      "The Website may contain links to third-party websites. We have no control over, and accept no responsibility for, the content or practices of any third-party site. Following such links is at your own discretion.",
    ],
  },
  {
    title: "Disclaimer of warranties",
    paragraphs: [
      "The Website is provided on an \"as is\" and \"as available\" basis. While we work to keep the Website accurate and available, we make no warranties, express or implied, regarding its completeness, accuracy, reliability or uninterrupted availability.",
    ],
  },
  {
    title: "Limitation of liability",
    paragraphs: [
      "To the maximum extent permitted by law, SefKam shall not be liable for any indirect, incidental or consequential damages arising out of or in connection with your use of the Website. Nothing in these terms excludes liability that cannot be excluded under applicable law.",
    ],
  },
  {
    title: "Privacy",
    paragraphs: [
      "Our handling of personal data submitted through this Website is described in our Privacy Policy, which forms part of these terms.",
    ],
  },
  {
    title: "Changes to these terms",
    paragraphs: [
      "We may revise these Terms of Service from time to time. The date at the top of this page reflects the latest revision. Continued use of the Website after changes take effect constitutes acceptance of the revised terms.",
    ],
  },
  {
    title: "Contact",
    paragraphs: [
      "For any questions about these terms, contact us at contact@sefkam.com.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      seo={{
        title: "Terms of Service | SefKam Digital Solutions",
        description: "The terms governing your use of sefkam.com, operated by SefKam Digital Solutions.",
        path: "/terms",
      }}
      eyebrow="Legal"
      title="Terms of Service"
      updated="June 2026"
      intro="These terms govern your use of sefkam.com. They are written to be read — short, clear, and without unnecessary legalese."
      sections={SECTIONS}
      testId="terms-page"
    />
  );
}
